import React, { useState } from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';


const LoginPage = () => {
    const [focusedField, setFocusedField] = useState(null);
    
  return (
    <div> 
        <Header></Header>
      <Container>
        <LoginForm>
            <h1>로그인</h1>
            <Form>
                <FormGroup focused={focusedField === "username"}>
                    <Label htmlFor="username">아이디</Label>
                    <Input
                        type="text"
                        id="username"
                        name="username"
                        placeholder="아이디를 입력하세요"
                        onFocus={() => setFocusedField("username")}
                        onBlur={() => setFocusedField(null)}
                    />
                </FormGroup>
                <FormGroup focused={focusedField === "password"}>
                    <Label htmlFor="password">비밀번호</Label>
                    <Input
                        type="password"
                        id="password"
                        name="password"
                        placeholder="비밀번호를 입력하세요"
                        onFocus={() => setFocusedField("password")}
                        onBlur={() => setFocusedField(null)}
                    />
                </FormGroup>
                <LoginButton type="submit">로그인</LoginButton>
                <Hr></Hr>
                <LoginKakaoButton type="submit">카카오 로그인</LoginKakaoButton>
                <LoginGoogleButton type="submit">Sign in with Google </LoginGoogleButton>
            </Form>
     
  

        </LoginForm>

      </Container>
   <Footer></Footer>
    </div>
  );
};

export default LoginPage;


const Container  = styled.div`
width:100%;
display: flex;
align-items:center;
justify-content:center;
`

const LoginForm = styled.div`
width:638px;
height:78vh;
display: flex;
align-items:center;
justify-content:center;
flex-direction: column;

`;


// 폼 그룹 스타일
export const Form = styled.form`

width:430px;
`;

export const FormGroup = styled.div`
    margin-bottom: 16px;
    position: relative;

    input {
        border-color: ${(props) => (props.focused ? "#3C3D37" : "#c1c1c1")};
    }
`;

export const Label = styled.label`
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
`;

// 입력 필드 스타일
export const Input = styled.input`
    width: 99%;
    height:56px;
   
    font-size: 14px;
    border: 1px solid #c1c1c1;
    border-radius: 4px;
    outline: none;
    transition: border-color 0.3s ease-in-out;

    &:focus {
        border-color: #3C3D37;
    }
`;

// 로그인 버튼 스타일
export const LoginButton = styled.button`
margin-bottom:15px;
    width: 100%;
    height:56px;
    font-size: 16px;
    color: #fff;
    background-color: #3C3D37;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;

    &:hover {
        background-color: #2e2e2b;
    }
`;

export const LoginKakaoButton = styled.button`
margin-bottom:15px;
    width: 100%;
    height:56px;
    font-size: 16px;
    color:#191919;
    background-color: #FEE500;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;

    &:hover {
        background-color: #F9D933;
    }
`;

export const LoginGoogleButton = styled.button`
    margin-bottom:15px;
    width: 100%;
    height:56px;
    font-size: 16px;
    border: 1px solid #747775;
    background-color: white;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;

    &:hover {
        background-color: #c1c1c1;
    }
`;

const Hr = styled.div`
width:98%;
border: 1px solid #3C3D37;
margin-bottom:15px;
`;